import { closeWaitlistPanel } from 'actions/waitlists/WaitlistsActions';
import { Drawer } from 'components/UI/V3/Drawer/Drawer';
import WaitlistDetail from 'components/Waitlist/WaitlistDetail/WaitlistDetail';
import WaitlistForm from 'components/Waitlist/WaitlistForm/WaitlistForm';
import WaitlistList from 'components/Waitlist/WaitlistList/WaitlistList';
import { FunctionComponent, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WaitlistsPanelState } from 'reducers/waitlists/WaitlistsState';
import { RootState } from 'store';
import styles from './WaitlistPanel.module.scss';
import { WaitlistPanelContext } from './WaitlistPanelContext';

// Rendered once in the app shell so it can be opened from the Bookings header and from notifications.
export const WaitlistPanel: FunctionComponent = () => {
    const dispatch = useDispatch();

    const panel = useSelector<RootState, WaitlistsPanelState>(state => state.waitlists.panel);

    const [hidden, setHidden] = useState(false);
    const context = useMemo(() => ({ setHidden }), []);

    if (!panel.open) {
        return null;
    }

    return (
        <WaitlistPanelContext.Provider value={context}>
            <Drawer
                hidden={hidden}
                onClose={() => dispatch(closeWaitlistPanel())}
            >
                {/* The list stays mounted behind the detail so filters and scroll survive going back. */}
                <div
                    className={styles.view}
                    hidden={panel.selectedWaitlistId !== undefined || panel.form !== undefined}
                >
                    <WaitlistList
                        initialKey={panel.key}
                        marketplaceIds={panel.marketplaceIds}
                    />
                </div>

                {panel.selectedWaitlistId !== undefined && (
                    <div
                        className={styles.view}
                        hidden={panel.form !== undefined}
                    >
                        <WaitlistDetail
                            waitlistId={panel.selectedWaitlistId}
                            marketplaceIds={panel.marketplaceIds}
                        />
                    </div>
                )}

                {panel.form !== undefined && (
                    <div className={styles.view}>
                        <WaitlistForm marketplaceIds={panel.marketplaceIds} />
                    </div>
                )}
            </Drawer>
        </WaitlistPanelContext.Provider>
    );
};

export default WaitlistPanel;
